var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoChecks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.263,
    height: 6.931,
    viewBox: "0 0 16.263 6.931",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4463",
    "data-name": "Group 4463",
    transform: "translate(-1369.869 -693.869)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3148",
    "data-name": "Group 3148",
    transform: "translate(1365.637 688.182)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3149",
    "data-name": "Group 3149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8489",
    "data-name": "Path 8489",
    d: "M13.364,6.818l-5.091,5L5.364,8.961",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4462",
    "data-name": "Group 4462",
    transform: "translate(1371.637 688.182)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3149-2",
    "data-name": "Group 3149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8489-2",
    "data-name": "Path 8489",
    d: "M13.364,6.818l-5.091,5-1.541-1.5",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoChecks);
export default __webpack_public_path__ + "static/media/two-checks.c111ccaf475cd70d6eeeae21cc0d241b.svg";
export { ForwardRef as ReactComponent };